import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import invert from "lodash/invert";
import {injectIntl} from "react-intl";
import {hashHistory} from "react-router";

// import {FormattedMessage} from "react-intl";
import {setActiveQuoteIndex, setQuotes} from "../../actions/roomsFunctions";
import {getCurrentLayout} from "../appLayout";
import {
  canShowSqftButton,
  getRoomName,
} from "../../misc/helpers";
import goToMaterialPage from "../common/goToMaterialPage";
import {clearCart, restoreCart, setCameFromPage} from "../../actions/actionFunctions";
import LayoutNavigationItem from "../visComponents/layoutNavigationItem";
import {checkIfNeedToSetNewCategory} from "../../misc/categorySwitchingFunctions";
import {setNewActiveQuote, updateCurrentQuote} from "../../misc/quotesFunctions";
import {CABINET_BOXES, SQFT_GROUP} from "../sqft/constants";
import {setSquareFootageGroup} from "../../actions/sqftFunctions";
import {cloneQuote, deleteQuote} from "../../actions/quotesActions";
import {checkIfNeedToChangeWizardOnRoomChange} from "../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {syncQuoteSqftCalcDataWithCart} from "../sqft/helpers/syncQuoteSqftCalcDataWithCart";


const Quote = (props) => {

  const {quotes, quote, quoteIndex, activeQuoteIndex, setActiveQuoteIndex, cartItems, intl, fabricatorData, setCameFromPage,
    setSquareFootageGroup, cloneQuote, deleteQuote, setQuotes} = props;
  // console.log("quote", quote);

  const quoteClick = async () => {
    if (quoteIndex !== activeQuoteIndex) {
      await updateCurrentQuote();
      checkIfNeedToChangeWizardOnRoomChange(quoteIndex);
      setActiveQuoteIndex(quoteIndex);
      await setNewActiveQuote(quoteIndex, quotes);
      checkIfNeedToSetNewCategory(quoteIndex);
    }
  };

  const quoteEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // remove quoteClick!
    if (checkIfNeedToSetNewCategory(activeQuoteIndex)) {
      goToMaterialPage("shoppingcart", false);
      return
    }
    goToMaterialPage("shoppingcart", true);
  };

  const quoteCalcClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // remove quoteClick!
    setCameFromPage("shoppingcart");

    const updatedQuotes = syncQuoteSqftCalcDataWithCart(quotes, quoteIndex, cartItems, getCurrentLayout(quote.room));
    if (updatedQuotes !== quotes) {
      setQuotes(updatedQuotes);
    }

    hashHistory.push("sqft");
    const updatedQuote = updatedQuotes[quoteIndex] || quote;
    const sqFtCalcData = updatedQuote.sqFtCalcData;
    if (sqFtCalcData) {
      const countertops = sqFtCalcData.countertops;
      if (countertops) {
        const hasCabinets = countertops.some(countertop => CABINET_BOXES.includes(countertop.partId));
        if (hasCabinets) {
          setSquareFootageGroup(SQFT_GROUP.cabinets);
          hashHistory.push("sqft?group=cabinets");
        }
      }
    }
  };

  const isActive = quoteIndex === activeQuoteIndex;

  const layout = getCurrentLayout(quote.room);
  let bgImageUrl = quote.staticCanvasImage || quote.bvImage;
  let layoutName = "";
  const layoutType = Number.isInteger(quote.layoutType) ? quote.layoutType : layout.type;
  if (Number.isInteger(layoutType) && !bgImageUrl) {
    layoutName = invert(layout.layoutTypes)[layoutType];
  }
  const styles = {
    backgroundImage: `url(${bgImageUrl})`
  }

  const severalQuotes = quotes.length > 1;
  const showSqft = canShowSqftButton();
  const buttonsClassNames = isActive
    ? showSqft && severalQuotes
      ? "quotes-button bg-center bg-no-repeat u-w-15 u-h-15"
      : "quotes-button bg-center bg-no-repeat"
    : "";

  return (
    <li className={"quotes-list__item" + (isActive ? " quotes-list__item--active" : "")}
        onClick={quoteClick} style={styles}>
      {severalQuotes ? (
        <h4 className="quotes-list__item-name bold">
          {getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData)}
        </h4>
      ) : null}
      {layoutName && !bgImageUrl ? <LayoutNavigationItem layout={layout} keyType={layoutName} imageOnly={true}/> : null}
      {isActive ? (
        <div className="absolute u-bottom-05 flex flex--between u-gap-025 u-left-0 quotes-list__item-buttons u-w-full">
          <button className={buttonsClassNames + " ui-edit quotes-button--edit"} onClick={quoteEditClick}/>
          {showSqft
            ? <button className={buttonsClassNames + " ui-calc quotes-button--calc"} onClick={quoteCalcClick}/>
            : null}
          <button className={buttonsClassNames + " ui-clone quotes-button--clone"} onClick={cloneQuote}/>
          {severalQuotes
            ? <button className={buttonsClassNames + " quotes-button--delete ui-delete"} onClick={deleteQuote}/>
            : null}
        </div>
      ) : null}
    </li>
  )
};

Quote.propTypes = {
  quote: PropTypes.object,
  quoteIndex: PropTypes.number,
}

const mapStateToProps = (store) => {
  return {
    windowWidth: store.serverState.windowWidth,
    quotes: store.quotesState.quotes,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    cartItems: store.cartState.cartItems,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setActiveQuoteIndex,
  setQuotes,
  clearCart,
  restoreCart,
  setCameFromPage,
  setSquareFootageGroup,
  cloneQuote,
  deleteQuote,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(Quote)
)
